var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 20C25.525 20 30 15.525 30 10C30 4.475 25.525 0 20 0C14.475 0 10 4.475 10 10C10 15.525 14.475 20 20 20ZM20 25C13.325 25 0 28.35 0 35V40H40V35C40 28.35 26.675 25 20 25Z",
    fill: "url(#paint0_linear_9_2294)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9_2294",
    x1: 20,
    y1: 0,
    x2: 20,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3086FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon3);
export default __webpack_public_path__ + "static/media/userIcon3.75197745bc47832d08f12960c77cd9a2.svg";
export { ForwardRef as ReactComponent };